module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/desenrola2x-69adb1768e0ef88f4ee8fcfc1ff3bf28.webp";